import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { useLL97CBLDisputeQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — CBL dispute detail lazy-loaded.
const CBLDisputeDetailPage = lazy(
  () => import("@/pages/CBLDisputes/Detail/Page"),
);

const CBLDisputeDetail = () => {
  const { ll97SubmissionId } = Route.useParams();
  const { data: dispute } = useLL97CBLDisputeQuery(ll97SubmissionId);
  const buildingName = dispute?.building?.name;

  return (
    <div className="flex flex-col w-full">
      <SiteHeader
        header={`CBL Dispute ${buildingName ? `for ${buildingName}` : ""}`}
        backLink="/cbl_disputes"
      />
      <Suspense fallback={null}>
        <CBLDisputeDetailPage />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute("/cbl_disputes/$ll97SubmissionId")({
  component: CBLDisputeDetail,
});
